import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PartyPopper, UserCircle, Pen } from 'lucide-react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from './ui/dialog';
import { useTranslation } from 'react-i18next';

interface WelcomeModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const WelcomeModal: React.FC<WelcomeModalProps> = ({ open, onOpenChange }) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const handleOk = () => {
    onOpenChange(false);
    navigate('/profile');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[440px]">
        <DialogHeader className="text-center sm:text-center">
          <div className="flex justify-center mb-2">
            <div className="w-14 h-14 rounded-full bg-amber-50 flex items-center justify-center">
              <PartyPopper className="h-7 w-7 text-amber-500" />
            </div>
          </div>
          <DialogTitle className="text-xl">{t('welcome.title')}</DialogTitle>
          <DialogDescription className="text-sm pt-1">
            {t('welcome.subtitle')}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 py-2">
          <div className="flex items-start gap-3 rounded-lg border p-3 bg-slate-50">
            <UserCircle className="h-5 w-5 text-primary mt-0.5 shrink-0" />
            <div>
              <p className="text-sm font-medium">{t('welcome.complete_profile')}</p>
              <p className="text-xs text-muted-foreground">{t('welcome.complete_profile_desc')}</p>
            </div>
          </div>
          <div className="flex items-start gap-3 rounded-lg border p-3 bg-slate-50">
            <Pen className="h-5 w-5 text-primary mt-0.5 shrink-0" />
            <div>
              <p className="text-sm font-medium">{t('welcome.upload_signature')}</p>
              <p className="text-xs text-muted-foreground">{t('welcome.upload_signature_desc')}</p>
            </div>
          </div>
        </div>

        <p className="text-xs text-muted-foreground text-center">{t('welcome.avatar_hint')}</p>

        <DialogFooter className="sm:justify-center">
          <Button onClick={handleOk} className="w-full sm:w-auto px-8">
            {t('welcome.ok_button')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeModal;
